export default __webpack_public_path__ + "static/media/vivi.2428e37a.svg";